import * as React from 'react'

const IconArrow = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m2.778 2.778 19.444 19.444"
      stroke="white"
      strokeWidth={4.861111111111111}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.222 2.778v19.444H2.778"
      stroke="white"
      strokeWidth={4.861111111111111}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default IconArrow
